"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class NodeContainer {
    constructor(expectedType) {
        this.expectedType = expectedType;
        this.id = NodeContainer.globalId++;
        /**
         * Is undefined if no value is set.
         */
        this.node = undefined;
    }
}
NodeContainer.globalId = 0;
__decorate([
    mobx_1.observable
], NodeContainer.prototype, "node", void 0);
exports.NodeContainer = NodeContainer;
class BaseNode {
    constructor(sourceType, actualType) {
        this.sourceType = sourceType;
        this.actualType = actualType;
        if (sourceType.resolveDefinition() !== actualType) {
            throw new Error("Invalid source type");
        }
    }
}
exports.BaseNode = BaseNode;
class ObjectNode extends BaseNode {
    constructor(sourceType, actualType) {
        super(sourceType, actualType);
        this.kind = "object";
        this.properties = {};
        for (const p of Object.values(actualType.properties)) {
            this.properties[p.name] = new ObjectNodeProperty(p);
        }
    }
    toJson() {
        const result = {};
        for (const [name, val] of Object.entries(this.properties)) {
            if (!val.container.node) {
                continue;
            }
            result[name] = val.container.node.toJson();
        }
        return result;
    }
}
__decorate([
    mobx_1.observable
], ObjectNode.prototype, "properties", void 0);
exports.ObjectNode = ObjectNode;
class ObjectNodeProperty {
    constructor(propertyInfo) {
        this.propertyInfo = propertyInfo;
        this.container = new NodeContainer(propertyInfo.type);
    }
    get name() {
        return this.propertyInfo.name;
    }
}
exports.ObjectNodeProperty = ObjectNodeProperty;
class MapNode extends BaseNode {
    constructor(sourceType, actualType) {
        super(sourceType, actualType);
        this.kind = "map";
        this.properties = [];
    }
    toJson() {
        const result = {};
        for (const val of this.properties) {
            if (!val.container || !val.container.node) {
                continue;
            }
            result[val.name] = val.container.node.toJson();
        }
        return result;
    }
}
__decorate([
    mobx_1.observable
], MapNode.prototype, "properties", void 0);
exports.MapNode = MapNode;
class MapNodeProperty {
    constructor(name, expectedType) {
        this.expectedType = expectedType;
        this.name = name;
        this.container = new NodeContainer(expectedType);
    }
}
__decorate([
    mobx_1.observable
], MapNodeProperty.prototype, "name", void 0);
exports.MapNodeProperty = MapNodeProperty;
class ArrayNode extends BaseNode {
    constructor() {
        super(...arguments);
        this.kind = "array";
        this.items = new Array();
    }
    toJson() {
        return this.items.map(i => (i.node ? i.node.toJson() : null));
    }
}
__decorate([
    mobx_1.observable
], ArrayNode.prototype, "items", void 0);
exports.ArrayNode = ArrayNode;
class PrimitiveNode extends BaseNode {
    constructor(sourceType, actualType, value) {
        super(sourceType, actualType);
        this.kind = "primitive";
        this.value = value;
    }
    get type() {
        const t = typeof this.value;
        if (t === "object" && !this.value) {
            return "null";
        }
        if (t === "boolean" || t === "string" || t === "number") {
            return t;
        }
        throw new Error(`Invalid type "${t}"!`);
    }
    toJson() {
        return this.value;
    }
}
__decorate([
    mobx_1.observable
], PrimitiveNode.prototype, "value", void 0);
exports.PrimitiveNode = PrimitiveNode;
//# sourceMappingURL=Node.js.map